import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { SVGPureIcon } from '@/ui';
import navbarStore from '@/store/navbar';
import CreateBtn from './create-btn';
import { Tooltip } from 'antd';
import userStore from '@src/store/user';
import aiSoHomeStore from '@/pages/search-home/store';
import ChatHistory from './chat-history';
import AisoHistory from './aiso-history';
import HistorySearch from './history-search';
import SearchInput from './search-input';
import historySearchStore from "@/store/historySearch";
import deleteMenuStore from './delete-mune/store';
import appLogger from '@public/log/monitor';
import globalStore from '@/store/global';
import localRobot from '@/common/localRobot.js';
import { useLocation } from 'react-router-dom'; // 导入路由钩子
import AppCheckBox from '@/ui/checkbox';
import { HelpOther } from '@/common/helper';
import chatStoreManager from '@/store/chat/manager';
import { useParams } from 'react-router-dom';

const Navbar = observer(({scene=""}) => {
  const { isCollapse, setIsCollapse } = navbarStore;
  const [showSearchInput, setShowSearchInput] = useState(false);
  const location = useLocation(); // 获取当前路由信息

  // panelType: chatHistory, aisoHistory, historySearch_chat, historySearch_aiso
  const [panelType, setPanelType] = useState('chatHistory');

  useEffect(() => {
    let newPanelType = panelType;
    if (historySearchStore.data.search !== '') {
      if (globalStore.isAiso()) {
        newPanelType = 'historySearch_aiso';
      } else {
        newPanelType = 'historySearch_chat';
      }
    } else {
      if (globalStore.isAiso()) {
        newPanelType = 'aisoHistory';
      } else {
        newPanelType = 'chatHistory';
      }
    }
    setPanelType(newPanelType);
    // console.log('panelType setPanelType', newPanelType);
  }, [historySearchStore.data.search]);

  useEffect(() => {
    setShowSearchInput(false);
    navbarStore.setSourceId(0);
    if (globalStore.isAiso()) {
        // console.log('panelType .setSourceId(1)');
        
        setPanelType('aisoHistory');
        navbarStore.setSourceId(1);
      } else {
        // console.log('panelType .setSourceId(2)');

        setPanelType('chatHistory');
        navbarStore.setSourceId(globalStore.isAgentPage() ? 3 : 2);
      }
  }, [location.pathname]);

  useEffect(() => {
    if (!isCollapse) {
      appLogger.log({
        key: 'aibot_home',
        action: 'show',
        page: 'aibot_home_side',
      });
    }
  }, [isCollapse]);

  const renderHeaderNormal = () => {
    return (
      <div
        className={[
          isCollapse ? '' : 'flex items-center h-40px mb-12px justify-end gap-10px mx-14px'
        ]}
      >
        {
          isCollapse 
          ? null 
          : <CreateBtn title={createTitle} onClick={handleCreateBtn} scene={scene}/>
        }
        <div className='flex items-center gap-10px'>
          {
            // isCollapse || !userStore.isUser
            isCollapse || deleteMenuStore.isEdit
            ? null 
            : (
              <Tooltip title="搜索历史">
                <div
                  onClick={evt => {
                    deleteMenuStore.exitEidt();
                    setShowSearchInput(true);
                  }}
                  className={[
                    userStore.isUser ? '' : 'invisible',
                    'size-24px group relative'
                  ]}
                >
                  <div className="absolute left-1/2 top-1/2 -ml-16px -mt-16px size-32px rounded-8px bg-[#00000008] hidden group-hover:block cursor-pointer"></div>
                  <SVGPureIcon
                    name="ic-search"
                    className={['size-24px cursor-pointer opacity-80']}
                  />
                </div>
              </Tooltip>
            )
          }
          {
            isCollapse || panelType !== 'aisoHistory'
            ? null 
            : (
              <Tooltip title="编辑">
                <div
                  onClick={evt => {
                    deleteMenuStore.doEidt();
                  }}
                  className={[
                    userStore.isUser ? '' : 'invisible',
                    'size-24px group relative'
                  ]}
                >
                  <div className="absolute left-1/2 top-1/2 -ml-16px -mt-16px size-32px rounded-8px bg-[#00000008] hidden group-hover:block cursor-pointer"></div>
                  <SVGPureIcon
                    name="ic-edit"
                    className={['size-24px cursor-pointer opacity-80']}
                  />
                </div>
              </Tooltip>
            )
          }
          <Tooltip className={globalStore.showChildIFrameModal ? 'hidden' : ''} title={isCollapse ? '展开侧栏' : '收起侧栏'}>
            <div
              onClick={evt => {
                setIsCollapse(!isCollapse);
                if (isCollapse) {
                  deleteMenuStore.exitEidt();
                }
              }}
              className={[
                'size-24px group relative',
                isCollapse ? "ml-24px mt-10px" : ""
              ]}
            >
              <div className="absolute left-1/2 top-1/2 -ml-16px -mt-16px size-32px rounded-8px bg-[#00000008] hidden group-hover:block cursor-pointer"></div>
              <SVGPureIcon
                name="ic-slider"
                className={['size-24px cursor-pointer relative z-1 opacity-80']}
              />
            </div>
          </Tooltip>
        </div>
      </div>
    );
  }

  const renderHeaderInput = () => {
    return (
      <div
        className={[
          'flex items-center h-40px mb-16px',
          isCollapse ? '' : 'ml-12px mr-8px'
        ]}
      >
        <SearchInput 
          searchCloseCb={() => {
            setShowSearchInput(false);
          }}
          scene={scene}
        />
      </div>
    );
  }

  const renderHeaderEditting = () => {
    const { id } = useParams();
    const checked = deleteMenuStore.deleteIds.length;
    const notAll =
      checked &&
      deleteMenuStore.deleteIds.length != navbarStore.historyList.length;

    return (
      <div className="flex items-start justify-center flex-col p-14px absolute bottom-0 z-999 w-full h-98px bg-[#F5F5F5]">
        <div className="flex items-center gap-8px">
          <AppCheckBox
            className="!block !w-16px !h-16px cursor-pointer"
            notAll={notAll}
            checked={checked}
            onClick={evt => {
              if (checked) {
                if (notAll && deleteMenuStore.deleteIds.length < 100) {
                  //全选
                  deleteMenuStore.checkAll();
                } else {
                  //取消全选
                  deleteMenuStore.uncheckAll();
                }
              } else {
                //全选
                deleteMenuStore.checkAll();
              }
            }}
          />
          <div className="text-14px font-500">
            已选择 {deleteMenuStore.deleteIds.length} 项
          </div>
        </div>

        <div className="flex items-center gap-12px mt-14px">
          <div
            onClick={deleteMenuStore.exitEidt}
            className="font-normal w-110px h-36px py-8px px-16px vh-center cursor-pointer bg-white hover:bg-[rgba(0,0,0,0.03)] rounded-6px border-1px border-solid border-[rgba(0,0,0,0.10)]"
          >
            {/* <SVGPureIcon
              name="delete_close"
              iconClass="text-primary"
              size={24}
            /> */}
            取消
          </div>
          <div
            onClick={evt => {
              if (!deleteMenuStore.deleteIds.length) return;
              HelpOther.confirm({
                title: '确认删除对话',
                okText: '删除',
                content: (
                  <div className="whitespace-nowrap">
                    确定要删除对话吗？删除后对话内容将不可恢复。
                  </div>
                ),
                onOk: () => {
                  const isHasCur = deleteMenuStore.deleteIds.includes(id);
                  if (isHasCur) {
                    navbarStore.clearHistory(
                        deleteMenuStore.deleteIds,
                        true
                      );
                  } else {
                    navbarStore.clearHistory(deleteMenuStore.deleteIds);
                  }
                  const isHomePage = location.pathname === '/';
                  appLogger.log({
                    key: `${isHomePage ? 'aibot_home' : 'aibot_chat'}`,
                    action: 'click',
                    arrt: 'del_chat',
                    conversation_id: deleteMenuStore.deleteIds.join(','),
                  });
                },
              });
              evt.stopPropagation();
            }}
            className={[
              'font-normal w-110px h-36px py-8px px-16px vh-center rounded-6px border-1px border-solid border-[rgba(0,0,0,0.10)] bg-[#FF3B30] opacity-30 text-white text-14px',
              deleteMenuStore.deleteIds.length ? 'cursor-pointer opacity-100 hover:bg-[#E1051B]' : '',
            ]}
          >
            {/* <SVGPureIcon
              name="icon_delete"
              iconClass={[
                'text-primary-opacity',
                deleteMenuStore.deleteIds.length ? '' : 'text-opacity-30',
              ]}
              size={16}
            /> */}
            删除
          </div>
        </div>
      </div>
    );
  }

  const renderPanel = () => {
    // if (!userStore.isUser) {
    //   return null;
    // }
    if (isCollapse) {
      return null;
    }

    switch (panelType) {
      case 'chatHistory':
        return <ChatHistory showSearchInput={showSearchInput} scene={scene}/>;
      case 'aisoHistory':
        return <AisoHistory />;
      
      case 'historySearch_aiso':
        if (userStore.isUser) {
          return <HistorySearch scene={scene} type={'aiso'}/>;
        }
      case 'historySearch_chat':
        if (userStore.isUser) {
          return <HistorySearch scene={scene} type={'chat'}/>;
        }
    }
    return null;
  };

  const handleCreateBtn = () => {
    if (panelType === 'chatHistory') {
      localRobot.destory();
      globalStore.gotoHome();
    }else if (panelType === 'aisoHistory') {
      localRobot.destory();
      aiSoHomeStore?.setShowCustomInputPage(false);
      globalStore.gotoSearchHome();
    }else if (panelType === 'historySearch_aiso') {
      
    }else if (panelType === 'historySearch_chat') {
      
    }
  }
  
  const createTitle = panelType === 'chatHistory' ? '新建对话' : '新搜索';

  useEffect(() => {
    if (isCollapse) {
      deleteMenuStore.exitEidt()
    }
  }, [isCollapse])

  if(userStore.isBrand && scene == "aigent") return null;

  return (
    <div
      style={{
        background: 'linear-gradient(180deg, #FFF 0%, #F5F5F5 20.03%)',
        boxShadow: globalStore.showChildIFrameModal ? 'none' : '0px 4px 8px 0px rgba(0, 0, 0, 0.12), 0px 0px 2px 0px rgba(0, 0, 0, 0.12)'
      }}
      className={[
        'pt-14px box-border',
        'w-260px h-100vh relative',
        'flex flex-col flex-shrink-0',
        'border-r-1px border-black-10 z-199 select-none',
        isCollapse ? "w-0px border-r-0px px-0px" : ""
      ]}
    >
      {deleteMenuStore.isEdit && globalStore.isAiso()
        ? renderHeaderEditting()
        : showSearchInput
          ? renderHeaderInput()
          : renderHeaderNormal()}
      { renderPanel() }
    </div>
  );
});
export default Navbar;
